var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsOffIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 50.6666V45.3333H16.0001V26.6666C16.0001 25.1999 16.189 23.7555 16.5667 22.3333C16.9445 20.911 17.5112 19.5555 18.2667 18.2666L26.6667 26.6666H19.2001L3.7334 11.1999L7.46673 7.46659L56.5334 56.5333L52.8001 60.2666L43.0667 50.6666H10.6667ZM48.0001 40.3999L21.8667 14.2666C22.7556 13.5555 23.7112 12.9333 24.7334 12.3999C25.7556 11.8666 26.8445 11.4666 28.0001 11.1999V9.33325C28.0001 8.22214 28.389 7.2777 29.1667 6.49992C29.9445 5.72214 30.889 5.33325 32.0001 5.33325C33.1112 5.33325 34.0556 5.72214 34.8334 6.49992C35.6112 7.2777 36.0001 8.22214 36.0001 9.33325V11.1999C39.5556 12.0888 42.4445 13.9666 44.6667 16.8333C46.889 19.6999 48.0001 22.9777 48.0001 26.6666V40.3999ZM32.0001 58.6666C30.5334 58.6666 29.2778 58.1444 28.2334 57.0999C27.189 56.0555 26.6667 54.7999 26.6667 53.3333H37.3334C37.3334 54.7999 36.8112 56.0555 35.7667 57.0999C34.7223 58.1444 33.4667 58.6666 32.0001 58.6666Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsOffIcon);
export default __webpack_public_path__ + "static/media/NotificationsOffIcon.c1cd4f30a7706a6a9d2fd208a1b4abcc.svg";
export { ForwardRef as ReactComponent };